import LoadingSpinner from "components/EvtKit/spinner/LoadingSpinner"
import useRouteAuth from "hooks/useRouteAuth"
import { ReactElement } from "react"
import { Navigate } from "react-router-dom"

interface PublicRouteProps {
  outlet: ReactElement
}

const PublicRoute = (props: PublicRouteProps) => {
  const { outlet } = props

  const { isAuthLoading, isAuthValid } = useRouteAuth()

  const token = localStorage.getItem("token")

  if (!token) {
    return outlet
  }

  if (isAuthLoading) {
    return <LoadingSpinner />
  }

  return !isAuthValid ? outlet : <Navigate to={{ pathname: "/home" }} replace />
}

export default PublicRoute
